import { render, staticRenderFns } from "./SelectCheckbox.vue?vue&type=template&id=495a99d3&"
import script from "./SelectCheckbox.js?vue&type=script&lang=js&"
export * from "./SelectCheckbox.js?vue&type=script&lang=js&"
import style0 from "./SelectCheckbox.vue?vue&type=style&index=0&id=495a99d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports